import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { PayByBillAction } from '../../common/actions/pay-by-bill.action';
import {
  PaymentProgressChangeAction,
  PaymentProgressStatus
} from '../../components/payment-progress/payment-progress.action';
import NotificationService from '../../common/services/notification/notification.service';
import { DistantSaleAction } from '../../common/actions/distant-sale-action';

/* @ngInject */
export default class PayByBillController {
  private distantAggreement: boolean = true;

  constructor(
    private $translate,
    private actionDispatcher: ActionDispatcherService,
    private notificationService: NotificationService
  ) {}

  public $onInit() {}

  public onConfirm(data: any) {
    this.distantAggreement = data.distant;
  }

  public onDistantSale() {
    this.actionDispatcher.dispatch(
      new DistantSaleAction('distant_sales_form_for_sdp', 'bill')
    );
  }

  public onNext() {
    if (!this.distantAggreement) {
      this.$translate('pay.distantError').then(value => {
        this.notificationService.showNotification({
          text: value,
          type: 'warning'
        });
      });
      return;
    }

    this.actionDispatcher.dispatch(new PayByBillAction());
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/pay-by-bill/pay-by-bill.controller.ts